import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

import { selectors } from '../modules/auth';

export default function PrivateRoute({ component: Component, ...rest }) {
  const { loginStatus } = useSelector(selectors.getAuth);
  return (
    <Route
      {...rest}
      render={props =>
        loginStatus ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location === '/login' ? '/' : props.location },
            }}
          />
        )
      }
    />
  );
}
